module.exports = __webpack_public_path__ + "img/pro-m-slider7.b4b88fa3.png";